const guiColors = {
    'color-scheme': 'dark',

    'ui-primary': 'rgba(30, 30, 36, 0.88)',
    'ui-secondary': '#1e1e22',
    'ui-tertiary': '#2e2e34',

    'ui-modal-overlay': 'rgba(0, 0, 0, 0.55)',
    'ui-modal-background': '#1c1c24',
    'ui-modal-foreground': '#f1f5f9',
    'ui-modal-header-background': '#252529',
    'ui-modal-header-foreground': '#ffffff',

    'ui-white': '#252529',
    'ui-white-dim': 'rgba(37, 37, 41, 0.75)',
    'ui-white-transparent': 'rgba(255, 255, 255, 0.12)',
    'ui-transparent': 'rgba(0, 0, 0, 0)',

    'ui-black-transparent': 'rgba(255, 255, 255, 0.08)',

    'text-primary': '#f1f5f9',
    'text-primary-transparent': 'rgba(148, 163, 184, 0.95)',

    'motion-primary': '#818cf8',
    'motion-primary-transparent': 'rgba(129, 140, 248, 0.9)',
    'motion-tertiary': '#6366f1',

    'looks-secondary': '#a78bfa',
    'looks-transparent': 'rgba(129, 140, 248, 0.35)',
    'looks-light-transparent': 'rgba(129, 140, 248, 0.15)',
    'looks-secondary-dark': '#764ba2',

    'menu-bar-background': 'rgba(28, 28, 36, 0.78)',
    'menu-bar-background-image': 'none',
    'menu-bar-foreground': '#f1f5f9',

    'assets-background': '#141418',

    'input-background': '#252529',

    'popover-background': '#252529',

    'badge-background': 'rgba(99, 102, 241, 0.15)',
    'badge-border': 'rgba(129, 140, 248, 0.25)',

    'fullscreen-background': '#141418',
    'fullscreen-accent': '#1c1c24',

    'page-background': '#141418',
    'page-foreground': '#f1f5f9',

    'project-title-inactive': 'var(--ui-secondary)',
    'project-title-hover': 'rgba(255, 255, 255, 0.35)',

    'link-color': '#818cf8',

    'filter-icon-black': 'invert(100%)',
    'filter-icon-gray': 'grayscale(100%) brightness(1.7)',
    'filter-icon-white': 'brightness(0) invert(100%)',

    'paint-filter-icon-gray': 'brightness(1.7)'
};

const blockColors = {
    insertionMarker: '#94a3b8',
    workspace: '#1e1e22',
    toolboxSelected: '#252529',
    toolboxText: '#cbd5e1',
    toolbox: '#141418',
    flyout: '#141418',
    scrollbar: '#64748b',
    valueReportBackground: '#252529',
    valueReportBorder: '#334155',
    valueReportForeground: '#f1f5f9',
    contextMenuBackground: '#1c1c24',
    contextMenuBorder: 'rgba(255, 255, 255, 0.08)',
    contextMenuForeground: '#f1f5f9',
    contextMenuActiveBackground: '#2e2e34',
    contextMenuDisabledForeground: '#64748b',
    flyoutLabelColor: '#94a3b8',
    checkboxInactiveBackground: '#252529',
    checkboxInactiveBorder: '#94a3b8',
    buttonBorder: '#64748b',
    buttonActiveBackground: '#252529',
    buttonForeground: '#cbd5e1',
    zoomIconFilter: 'invert(100%)',
    gridColor: '#334155'
};

export {
    guiColors,
    blockColors
};
